import useLightbox from "./use-lightbox";

export default function LightboxRoot() {
  const { Lightbbox } = useLightbox();

  return <>{Lightbbox}</>;
}
